let stripePublishableKey = ''

export const configureCheckout = ({ publishableKey }: { publishableKey: string }) => {
    stripePublishableKey = publishableKey
}

export const getStripePublishableKey = () => stripePublishableKey
